import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadContactTags = async () => {
  try {
    const response = await Axios.get('tags');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadContactTag = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('setups/product-categories');
        // const responseData = await response.data;
        // return {...responseData, category: {}};
        return {};
        
      default:
        const respnse = await Axios.get('tags/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useContactTagAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('tags', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('tag_created', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('tags/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('tag_update', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useContactTagAPI;


